import React from 'react';

const OfficeDetiles = ({ office }) => {
  return (
    <div className="office-data">
      <span>
        <i className="bi bi-geo-alt"></i> {office.address}
      </span>
      <span>
        <i className="bi bi-clock"></i> {office.time}
      </span>
      <span>
        <i className="bi bi-telephone-fill"></i> {office.phone}
      </span>
    </div>
  );
};

export default OfficeDetiles;
